import { LinearGradient } from "expo-linear-gradient";
import { router, useLocalSearchParams } from "expo-router";
import React from "react";
import {
  ScrollView,
  StatusBar,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import useUserStore from "@/store/user";
import * as Clipboard from "expo-clipboard";
import { showSuccess } from "@/utils/toast";
import { Image } from "expo-image";
import { FontFamilies } from "@/constants/Typography";
import LottieConfetti from "@/components/LottieConfetti";

const ConfigurationScreen = () => {
  const { title, description, image } = useLocalSearchParams();
  const { userProfile } = useUserStore();
  const link = `https://usesparrow.onelink.me/h5cL/iamwg19q?deep_link_value=${userProfile?.id}`;
  const handleCopyLink = () => {
    // Handle copy link functionality
    Clipboard.setStringAsync(link);
    showSuccess("Link copied to clipboard");
  };

  const handleClose = () => {
    router.dismissTo("/(tabs)/feeds");
  };

  const remainingClaims = Number(userProfile?.userCredits || 0);
  const remainingClaimsText = remainingClaims === 1 ? "claim" : "claims";

  return (
    <View style={styles.container}>
      <StatusBar barStyle="light-content" />
      <LinearGradient colors={["#26913B", "#243D3C"]} style={styles.gradient}>
        {/* Close Button */}
        <TouchableOpacity style={styles.closeButton} onPress={handleClose}>
          <Text style={styles.closeButtonText}>✕</Text>
        </TouchableOpacity>

        <ScrollView contentContainerStyle={styles.scrollContent}>
          <View style={styles.mainContent}>
            {/* Main Content */}
            {image && (
              <Image
                source={{ uri: image as string }}
                style={styles.image}
                contentFit="contain"
              />
            )}
            <Text style={styles.mainTitle}>
              {title || `Configuration\ncompleted successfully!`}
            </Text>

            <Text style={styles.subtitle}>
              {description ||
                "Share your experience and invite\nfriends to join Sparrow."}
            </Text>
          </View>

          {/* Link Sharing Section */}
          <View>
            <View style={styles.linkContainer}>
              <Text style={styles.linkInput} numberOfLines={1}>
                {link}
              </Text>
              <TouchableOpacity
                style={styles.copyButton}
                onPress={handleCopyLink}
              >
                <Text style={styles.copyButtonText}>Copy link</Text>
              </TouchableOpacity>
            </View>
            <Text style={styles.inviteText}>
              You have {remainingClaims} free {remainingClaimsText} remaining.
              {"\n"}
              Invite a friend to get 1 free.
            </Text>
          </View>
        </ScrollView>
        <LottieConfetti active={true} />
      </LinearGradient>
    </View>
  );
};

export default ConfigurationScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  gradient: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    paddingHorizontal: 20,
    paddingBottom: 40,
    justifyContent: "center",
  },
  mainContent: {
    alignItems: "center",
    marginBottom: 40,
  },
  mainTitle: {
    fontSize: 30,
    fontFamily: FontFamilies.InterTight.Medium,
    color: "white",
    textAlign: "center",
    marginBottom: 20,
    lineHeight: 40,
  },
  subtitle: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#FFFFFF",
    textAlign: "center",
    lineHeight: 24,
  },
  linkContainer: {
    flexDirection: "row",
    backgroundColor: "white",
    borderRadius: 8,
    padding: 8,
    alignItems: "center",
  },
  linkInput: {
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: 12,
    fontSize: 16,
    color: "#666",
  },
  copyButton: {
    backgroundColor: "#0F9129",
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 20,
  },
  copyButtonText: {
    color: "white",
    fontSize: 16,
    fontWeight: "600",
  },
  closeButton: {
    position: "absolute",
    top: 60,
    right: 20,
    padding: 8,
    borderRadius: 15,
    zIndex: 10,
  },
  closeButtonText: {
    color: "white",
    fontSize: 20,
    fontWeight: "bold",
  },
  inviteText: {
    fontSize: 15,
    fontFamily: FontFamilies.InterTight.Regular,
    color: "white",
    textAlign: "center",
    marginTop: 20,
  },
  image: {
    width: 120,
    height: 120,
    alignSelf: "center",
    borderRadius: 60,
    borderWidth: 2,
    borderColor: "#FFFFFF33",
    marginBottom: 25,
  },
});
